import { useRef } from "react";
import { useKanbanColumnNavigation } from "./useKanbanColumnNavigation";
import { useKanbanScrollHints } from "./useKanbanScrollHints";
import type {
  UseKanbanBoardScrollInput,
  UseKanbanBoardScrollResult,
} from "./kanban-scroll-types";

export type { ScrollHintState, SetColumnRefInput } from "./kanban-scroll-types";

export function useKanbanBoardScroll({
  clearHoveredCard,
  columnCount,
}: UseKanbanBoardScrollInput): UseKanbanBoardScrollResult {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const columnRefs = useRef<Array<HTMLDivElement | null>>([]);
  const scrollHintAnimationFrameRef = useRef<number | null>(null);
  const scrollHintState = useKanbanScrollHints({
    columnCount,
    scrollContainerRef,
    scrollHintAnimationFrameRef,
  });
  const navigation = useKanbanColumnNavigation({
    clearHoveredCard,
    columnCount,
    columnRefsRef: columnRefs,
    scrollContainerRef,
  });

  return {
    scrollContainerRef,
    scrollHintState,
    setColumnRef: navigation.setColumnRef,
    handleScrollToPrevColumn: navigation.handleScrollToPrevColumn,
    handleScrollToNextColumn: navigation.handleScrollToNextColumn,
  };
}
